import type { NextWorkflowError } from 'models/NextWorkflowError';
import { connect } from 'react-redux';
import { addonSelector, getIsUserInternal } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  errors?: readonly NextWorkflowError[];
  shouldDisplayErrorDetails: boolean;
  shouldDisplayStandardErrorMessage?: boolean;
}

export type RejectedState = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const isInternal = getIsUserInternal(state);

  const errors = addonSelector.getQuoteRejections(state, tabId);
  return {
    errors,
    shouldDisplayErrorDetails: isInternal,
    shouldDisplayStandardErrorMessage: !isInternal,
  };
};

export const connectQuoteRejected = connect(mapStateToProps);
